import { render, staticRenderFns } from "./public-quiz-question-answer-edit.html?vue&type=template&id=42977c7f&scoped=true&"
import script from "./public-quiz-question-answer-edit.js?vue&type=script&lang=js&"
export * from "./public-quiz-question-answer-edit.js?vue&type=script&lang=js&"
import style0 from "./public-quiz-question-answer-edit.scss?vue&type=style&index=0&id=42977c7f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42977c7f",
  null
  
)

export default component.exports